export const initialGlobalConfig = {}